import Cookies from "js-cookie";

window.showOutdatedBrowserNotice=false;
if ((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) { // IF IE
    window.showOutdatedBrowserNotice=true;
}
if(Cookies.get('ignoreoutdatedbrowsernotice')==='yes'){
    window.showOutdatedBrowserNotice=false;
}
if(window.showOutdatedBrowserNotice){
    let notice = document.getElementById('outdatebrowsernotice');
    let app = document.getElementById('app');
    let body = document.getElementsByTagName('body')[0];
    if(notice){
        notice.classList.remove('d-none');
        app.classList.add('blurred');
        body.classList.add('no-scroll');
    }
}

window.hideOutdatedBrowserNotice = function(){
    window.showOutdatedBrowserNotice=true;
    let notice = document.getElementById('outdatebrowsernotice');
    let app = document.getElementById('app');
    let body = document.getElementsByTagName('body')[0];
    if(notice){
        notice.classList.add('d-none');
        app.classList.remove('blurred');
        body.classList.remove('no-scroll');
        Cookies.set('ignoreoutdatedbrowsernotice', 'yes')
    }
}